import { render, staticRenderFns } from "./BankAccountCreationModal.vue?vue&type=template&id=1f3c9d2b&scoped=true&"
import script from "./BankAccountCreationModal.vue?vue&type=script&lang=ts&"
export * from "./BankAccountCreationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3c9d2b",
  null
  
)

export default component.exports